import './styles/main.scss';
import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';

let isMenuOpen = false;
const fastDom = {};
fastDom.menu = document.getElementById('nav-menu');
fastDom.navbar = document.getElementById('navbar');
fastDom.slider = document.getElementById('slider');
fastDom.toggler = document.getElementById('nav-toggler');

const sliderOptions = {
  arrows: false,
  autoplay: true,
  direction: 'rtl',
  interval: 5000,
  lazyLoad: 'sequential',
  paginationDirection: 'rtl',
  paginationKeyboard: false,
  speed: 500,
  type: 'loop', // loop, slide, fade
  width: '100%',
};
const slider = new Splide('#slider', sliderOptions);
// slider.mount();
// eslint-disable-next-line no-console
console.log('app mounted');

// listener
document.addEventListener('DOMContentLoaded', () => {
  // eslint-disable-next-line no-console
  console.log('dom mounted and ready');
  slider.mount();
});

document.addEventListener('scroll', onScroll);

fastDom.toggler.addEventListener('click', onToggleMenu);

fastDom.menu.addEventListener('focusout', onMenuFocusout);

slider.on('mounted', () => {
  // eslint-disable-next-line no-console
  console.log('slider mounted');
  fastDom.slider.classList.add('is-rendered');
});

// utility
function addClass(el, c) {
  if (!el) return;
  el.classList.add(c);
}

function removeClass(el, c) {
  if (!el) return;
  el.classList.remove(c);
}

// function saveScrollPosition() {
//   window.sessionStorage.setItem('scrollPosition', String(window.scrollY));
// }

function toggleClass(el, c) {
  if (!el) return;
  el.classList.toggle(c);
}

// methods
function onMenuFocusout() {
  // eslint-disable-next-line no-console
  console.log('menu focusout');
  isMenuOpen = false;
  // removeClass(document.body, 'lock-body');
  removeClass(fastDom.navbar, 'navbar--active');
  fastDom.toggler.setAttribute('aria-expanded', String(isMenuOpen));
}

function onScroll() {
  if (window.scrollY > 98) {
    addClass(fastDom.navbar, 'navbar--scrolled');
  } else {
    removeClass(fastDom.navbar, 'navbar--scrolled');
  }
}

function onToggleMenu(event) {
  event.preventDefault();
  // eslint-disable-next-line no-console
  console.log('toggle menu');
  isMenuOpen = !isMenuOpen;
  // saveScrollPosition();
  // toggleClass(document.body, 'lock-body');
  toggleClass(fastDom.navbar, 'navbar--active');
  fastDom.toggler.setAttribute('aria-expanded', String(isMenuOpen));
}

// export default {
//   fastDom,
//   slider,
//   toggleMenu: onToggleMenu,
// };
